"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opcionesGeneralesImpresionDefecto = void 0;
exports.opcionesGeneralesImpresionDefecto = {
    descuentosPUnitarios: false,
    descuentosImportes: false,
    preciosConIVA: false,
    codigos: false,
    discriminarTasas: true,
    txtAdicional: "",
    imprimirMediosPago: false,
    anchoCompletoDscLarga: false,
    colorEncabezados: "#7a7a7a",
    colorLetra: "black",
    tamanoLetra: "2",
    tamanoLetraEncabezados: "2",
    margenTablas: "1",
    separacionItems: "1",
    tamanoLetraTicket: "2",
    imprimirCotizacion: false
};
